import Cookies from 'js-cookie';

import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

interface PostUserSessionValues {
  network_id: number;
  redirect_to: string | undefined;
  user: {
    email: string;
    network_id: number;
    otp_attempt?: string;
    password: string;
    remember_me: number;
    timezone: string;
  };
}

export const postUserSession = async (values: PostUserSessionValues) => {
  const {
    data: { redirect_to: redirectTo },
  } = await axios.post(Routes.user_session_path({ format: 'json' }), values);

  const cookiesConsentListData = Cookies.get('cookie_consent_list_fo');

  if (cookiesConsentListData) {
    const cookiesConsentList = JSON.parse(cookiesConsentListData);

    if (
      cookiesConsentList.tracking?.find(
        (cookie) => cookie.name === 'Google analytics',
      )?.accepted
    ) {
      Cookies.set('login_method', 'email', { expires: 1 });
    }
  }

  const redirectUrl = redirectTo.startsWith('http')
    ? redirectTo
    : `${window.location.origin}${redirectTo}`;

  // when url contains storage open in new tab
  if (redirectUrl.includes('storage')) {
    window.open(redirectUrl, '_blank');

    window.location.href = window.location.origin;
  } else {
    window.location.href = redirectUrl;
  }

  toast.success(I18n.t('devise.sessions.signed_in'));
};
